// removed by extract-text-webpack-plugin
module.exports = {"ButtonContainer":"_3b-uWgwWWVVDGGbBr9XNLf"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Questions/SortButton/style.css
// module id = 2041
// module chunks = 0